
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";

const FAQ = () => {
  const faqs = [
    {
      question: "How much time do I need to commit to this course?",
      answer: "The course is designed to be flexible with your schedule. There are at least 8 sessions based on the course materials. Most students spend 3-5 hours per week to onboard, set up and understand the systems, then just 10-15m per day or so for monitoring & adjustments."
    },
    {
      question: "Do I need prior experience with cryptocurrency?",
      answer: "No prior experience is necessary. We start with the fundamentals and gradually build up to advanced strategies with a natural teacher. Complete beginners have successfully completed our course and are trading well!"
    },
    {
      question: "What kind of returns can I expect?",
      answer: "While results vary based on market conditions & individual strategy implementation, our students have reported monthly returns ranging from 10-30% on stablecoin pairs and 5-8+% on blue-chip BTC pairs. More if more risk is taken. As seen in our testimonials, all students have recouped their investment within the first weeks so far."
    },
    {
      question: "Is this riskier than traditional investments?",
      answer: "Our strategies focus primarily on capturing reliable & famous volatility in spot crypto trading avoiding all futures, leverage, margin or options, significantly reducing risk. We strongly emphasise capital preservation alongside growth and teach proper research based, trend observation risk management approaches. Gridbot trading is known to be one of the soundest strategies with the lowest risk."
    },
    {
      question: "What tools do I need to get started?", 
      answer: "You'll need a laptop as a minimum with internet access, funds to invest (we recommend starting with at least $3K) & a subscription to the platform we use which is paid for by the bot in generally less than a day by just a bot depending on your capital allocation. Most students have several running round the clock."
    }
  ];

  return (
    <section id="faq" className="py-20 bg-black">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-center mb-4 gap-2">
          <HelpCircle className="h-8 w-8 text-[#33C3F0]" />
          <h2 className="text-3xl md:text-4xl font-bold text-center text-white">Frequently Asked Questions</h2>
        </div>
        <p className="text-center text-gray-400 mb-12 max-w-2xl mx-auto">
          Everything you need to know about our crypto trading course
        </p>
        
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="border border-gray-700 rounded-lg overflow-hidden bg-black/60 backdrop-blur-md"
              >
                <AccordionTrigger className="px-6 py-4 hover:no-underline hover:bg-gray-800/30 text-white">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-4 pt-2 text-gray-300">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
